import { render, staticRenderFns } from "./edit-contract-form.vue?vue&type=template&id=bd627c42&"
import script from "./edit-contract-form.vue?vue&type=script&lang=js&"
export * from "./edit-contract-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports